import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { trackEvent } from '../analytics';
import ShareModal from './ShareModal';

var CardWrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 400px;
  padding: 1.5rem 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background: white;
  border: 1px solid #ddd;
  border-right-width: 2px;
  border-bottom-width: 2px;
  border-radius: 12px;
  position: relative;

  @media (max-width: 360px) {
    padding: 1rem 1rem;
  }
`;

var DismissButton = styled.button`
  position: absolute;
  top: 0.5rem;
  right: 0.75rem;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.1rem;
  color: #bbb;
  line-height: 1;
  padding: 0;

  &:hover {
    color: #666;
  }
`;

var CardTitle = styled.div`
  font-weight: 800;
  font-size: 1rem;
  margin-bottom: 0.35em;
`;

var CardSubtitle = styled.div`
  color: #777;
  font-size: 0.85rem;
  line-height: 1.4;
  margin-bottom: 1em;
`;

var CardButton = styled(Link)`
  display: inline-block;
  background: black;
  color: white;
  text-decoration: none;
  font-weight: 700;
  font-size: 0.85rem;
  padding: 0.55em 1.5em;
  border-radius: 8px;

  &:hover {
    background: #333;
  }
`;

var CardButtonExternal = styled.a`
  display: inline-block;
  background: black;
  color: white;
  text-decoration: none;
  font-weight: 700;
  font-size: 0.85rem;
  padding: 0.55em 1.5em;
  border-radius: 8px;

  &:hover {
    background: #333;
  }
`;

var CardActionButton = styled.button`
  display: inline-block;
  background: black;
  color: white;
  border: none;
  font-family: inherit;
  font-weight: 700;
  font-size: 0.85rem;
  padding: 0.55em 1.5em;
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background: #333;
  }
`;

var CardSecondaryButton = styled.button`
  display: inline-block;
  background: white;
  color: black;
  border: 1px solid black;
  border-right-width: 2px;
  border-bottom-width: 2px;
  font-weight: 700;
  font-size: 0.85rem;
  padding: 0.55em 1.5em;
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background: #f5f5f5;
  }
`;

var CardSecondaryLink = styled(Link)`
  display: inline-block;
  background: white;
  color: black;
  text-decoration: none;
  border: 1px solid black;
  border-right-width: 2px;
  border-bottom-width: 2px;
  font-weight: 700;
  font-size: 0.85rem;
  padding: 0.55em 1.5em;
  border-radius: 8px;

  &:hover {
    background: #f5f5f5;
  }
`;

var CardButtons = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

function CTACard(props) {
  var _localDismissed = useState(false);
  var localDismissed = _localDismissed[0];
  var setLocalDismissed = _localDismissed[1];

  var _showShare = useState(false);
  var showShare = _showShare[0];
  var setShowShare = _showShare[1];

  if (localDismissed || props.dismissed) return null;

  function handleDismiss() {
    trackEvent('cta_dismissed', { cta: props.dismissKey });
    if (props.onDismiss) {
      props.onDismiss(props.dismissKey);
    }
    setLocalDismissed(true);
  }

  function handleClick() {
    trackEvent('cta_clicked', {
      cta: props.dismissKey || props.title,
      // A button that opens a menu rather than going somewhere names it.
      destination: props.to || props.href || props.analyticsDestination,
    });
    if (props.dismissOnClick && props.onDismiss) {
      props.onDismiss(props.dismissKey);
    }
  }

  return (
    <CardWrapper>
      {props.dismissKey && (
        <DismissButton onClick={handleDismiss} aria-label="Dismiss">
          &times;
        </DismissButton>
      )}
      {props.children}
      {props.title && <CardTitle>{props.title}</CardTitle>}
      {props.subtitle && <CardSubtitle>{props.subtitle}</CardSubtitle>}
      <CardButtons>
        {props.onButtonClick && props.buttonText ? (
          <CardActionButton
            {...(props.buttonProps || {})}
            onClick={function (e) {
              handleClick();
              props.onButtonClick(e);
            }}
          >
            {props.buttonText}
          </CardActionButton>
        ) : props.href && props.buttonText ? (
          <CardButtonExternal
            href={props.href}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleClick}
          >
            {props.buttonText}
          </CardButtonExternal>
        ) : props.to && props.buttonText ? (
          <CardButton to={props.to} onClick={handleClick}>
            {props.buttonText}
          </CardButton>
        ) : null}
        {props.secondaryTo && props.secondaryText && (
          <CardSecondaryLink to={props.secondaryTo}>{props.secondaryText}</CardSecondaryLink>
        )}
        {props.shareUrl && (
          <CardSecondaryButton
            onClick={function () {
              if (props.onShareClick) props.onShareClick();
              setShowShare(true);
            }}
          >
            Share My Profile
          </CardSecondaryButton>
        )}
      </CardButtons>
      {showShare && (
        <ShareModal
          url={props.shareUrl}
          title="Share Profile"
          shareType="profile"
          imageData={props.shareImageData}
          onClose={function () {
            setShowShare(false);
          }}
        />
      )}
    </CardWrapper>
  );
}

export default CTACard;
